import { AccountObjectDto } from "../account-object/account-object.dto";
import { Control } from "../control/control.model";
import { DtoIncludeJson, DtoRef } from "../../../core/store/dto/dto";

export class FieldDto extends AccountObjectDto {
    @DtoRef
    control: string | Control;
    job: string;
    @DtoIncludeJson
    value: string;
    version: number;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/field/field.dto.ts